module.exports = __webpack_public_path__ + "img/logo.ef07f709.png";